import { connect } from 'react-redux';
import { selectCurrentBrandVersion } from 'selectors';
import Pages from 'app/layout/components/Pages';

const mapStateToProps = (state) => ({
  isNewVersion: selectCurrentBrandVersion(state),
});

export default connect(mapStateToProps)(Pages);
